import { Component, OnInit, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { NgForm } from '@angular/forms'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { UntypedFormBuilder, FormControl, UntypedFormGroup } from '@angular/forms'

import { SiteService } from '../../../../services/site.service'
import { MessageService } from '../../../../services/message.service'
import { TranslateService } from '@ngx-translate/core'
import { CustomerRequestsService } from '../../../../services/customer-requests.service'

import { ErrorMessageModalComponent } from '../../../modals/error-message-modal/error-message-modal.component'

@Component({
    selector: 'app-request-email-change-validation',
    templateUrl: './request-email-change-validation.component.html',
    styleUrls: ['./request-email-change-validation.component.scss'],
    standalone: false
})
export class RequestEmailChangeValidationComponent implements OnInit 
{
  @ViewChild('customForm') public customForm: NgForm

  customFormGroup: UntypedFormGroup
  formSubmitted: boolean = false
  isActiveLease: boolean = true
  isValidCode: boolean = true
  numberOfAttempts: number = 0

  request =
  {
    emailValidationCode: '',
  }
  referenceNumber: string = ''
  requestSummaryList: { key: string; value: string }[]

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private siteService: SiteService,
    private messageService: MessageService,
    private translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private customerRequestsService: CustomerRequestsService
  ) 
  { 
  }

  ngOnInit() 
  {
    this.referenceNumber = this.siteService.viewParameters.requestEmailChangeValidation.referenceNumber
    this.requestSummaryList = this.siteService.viewParameters.requestEmailChangeValidation.requestSummaryList
  }

  submitForm(customerForm: NgForm)
  {
    this.formSubmitted = true

    if (customerForm.invalid)
    {
      return
    }

    let changeRequest =
    {
      emailValidationCode: this.request.emailValidationCode.trim(),
      referenceNumber: this.referenceNumber
    }

    this.messageService.startedHttpRequest('submitForm')
    this.customerRequestsService
    .addEmailChangeRequest(changeRequest)
			.subscribe({
				next: (apiResponse) =>
        {
          this.isValidCode = apiResponse

          if ((this.isValidCode != undefined) && (this.isValidCode))
          {
            this.customerRequestsService.requestSummary(this.referenceNumber, this.translateService.instant('REQUEST_EMAIL_CHANGE_HEADING'), this.requestSummaryList)
          
            this.router.navigate(['/request-list'])
          }
          else
          {
            this.numberOfAttempts++

            if(this.numberOfAttempts == 5)
            {
              this.request.emailValidationCode = ' '
              this.isValidCode = true
            }
          }
        },
				error: (error) =>
				{
					this.messageService.completedHttpRequest('submitForm')

					const dialogConfig = new MatDialogConfig()
					dialogConfig.width = '500px',
					dialogConfig.data = {
						title: this.translateService.instant('COMMON_LBL_ERROR'),
						message: this.translateService.instant('COMMON_LBL_ERROR_MSG'),
					}
					
					this.dialog.open(ErrorMessageModalComponent, dialogConfig)
				},
				complete: () =>
				{
					this.messageService.completedHttpRequest('submitForm')
				}
			})
  }
}
